import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { formatPhoneNumber } from '../../pages/ClientIntake';
import { PersonInput } from './PersonSelect';

export default function POAStep({ form, updateForm, addPersonToList }) {
    const updatePOA = (f, v) => updateForm({ power_of_attorney: { ...form.power_of_attorney, [f]: v } });
    const el = React.createElement;

    return el('div', { className: 'space-y-8' },
        // Primary POA Section
        el('div', { className: 'p-4 border border-stone-200 space-y-4' },
            el('h4', { className: 'font-serif text-lg' }, 'Primary Power of Attorney Agent'),
            el('p', { className: 'text-sm text-muted-foreground' }, 'Person authorized to make financial decisions'),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Agent Name'),
                    el(PersonInput, { 
                        value: form.power_of_attorney.financial_poa_name, 
                        onChange: (val) => updatePOA('financial_poa_name', val), 
                        onAddPerson: addPersonToList,
                        people: form.people || [],
                        spouse: form.spouse,
                        children: form.children,
                        placeholder: 'Select or type name',
                        relationship: 'financial poa'
                    })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Pronouns'),
                    el('select', { 
                        value: form.power_of_attorney.financial_poa_gender || '', 
                        onChange: e => updatePOA('financial_poa_gender', e.target.value),
                        className: 'w-full h-10 px-3 border border-stone-200 bg-white rounded-none',
                        'data-testid': 'financial-poa-gender-select'
                    },
                        el('option', { value: '' }, 'Select...'),
                        el('option', { value: 'male' }, 'He/Him'),
                        el('option', { value: 'female' }, 'She/Her'),
                        el('option', { value: 'neutral' }, 'They/Them')
                    )
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Relationship'),
                    el(Input, { value: form.power_of_attorney.financial_poa_relationship, onChange: e => updatePOA('financial_poa_relationship', e.target.value), className: 'rounded-none', placeholder: 'e.g., spouse, daughter' })
                )
            ),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Phone'),
                    el(Input, { type: 'tel', value: form.power_of_attorney.financial_poa_phone || '', onChange: e => updatePOA('financial_poa_phone', formatPhoneNumber(e.target.value)), className: 'rounded-none', placeholder: '(555) 555-5555' })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'County'),
                    el(Input, { value: form.power_of_attorney.financial_poa_county || '', onChange: e => updatePOA('financial_poa_county', e.target.value), className: 'rounded-none', placeholder: 'e.g., Chesterfield' })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'State'),
                    el(Input, { value: form.power_of_attorney.financial_poa_state || '', onChange: e => updatePOA('financial_poa_state', e.target.value), className: 'rounded-none', placeholder: 'e.g., Virginia' })
                )
            )
        ),
        
        // Alternate POA Section
        el('div', { className: 'p-4 border border-stone-200 space-y-4' },
            el('h4', { className: 'font-serif text-lg' }, 'Alternate Power of Attorney Agent'),
            el('p', { className: 'text-sm text-muted-foreground' }, 'Backup agent if primary is unavailable'),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Agent Name'),
                    el(PersonInput, { 
                        value: form.power_of_attorney.financial_poa_alternate, 
                        onChange: (val) => updatePOA('financial_poa_alternate', val), 
                        onAddPerson: addPersonToList,
                        people: form.people || [],
                        spouse: form.spouse,
                        children: form.children,
                        placeholder: 'Select or type name',
                        relationship: 'alternate financial poa'
                    })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Pronouns'),
                    el('select', { 
                        value: form.power_of_attorney.financial_poa_alternate_gender || '', 
                        onChange: e => updatePOA('financial_poa_alternate_gender', e.target.value),
                        className: 'w-full h-10 px-3 border border-stone-200 bg-white rounded-none',
                        'data-testid': 'financial-poa-alternate-gender-select'
                    },
                        el('option', { value: '' }, 'Select...'),
                        el('option', { value: 'male' }, 'He/Him'),
                        el('option', { value: 'female' }, 'She/Her'),
                        el('option', { value: 'neutral' }, 'They/Them')
                    )
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Relationship'),
                    el(Input, { value: form.power_of_attorney.financial_poa_alternate_relationship || '', onChange: e => updatePOA('financial_poa_alternate_relationship', e.target.value.toLowerCase()), className: 'rounded-none', placeholder: 'e.g., daughter, son, friend' })
                )
            ),
            el('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-4' },
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'Phone'),
                    el(Input, { type: 'tel', value: form.power_of_attorney.financial_poa_alternate_phone || '', onChange: e => updatePOA('financial_poa_alternate_phone', formatPhoneNumber(e.target.value)), className: 'rounded-none', placeholder: '(555) 555-5555' })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'County'),
                    el(Input, { value: form.power_of_attorney.financial_poa_alternate_county || '', onChange: e => updatePOA('financial_poa_alternate_county', e.target.value), className: 'rounded-none', placeholder: 'e.g., Chesterfield' })
                ),
                el('div', { className: 'space-y-2' },
                    el(Label, null, 'State'),
                    el(Input, { value: form.power_of_attorney.financial_poa_alternate_state || '', onChange: e => updatePOA('financial_poa_alternate_state', e.target.value), className: 'rounded-none', placeholder: 'e.g., Virginia' })
                )
            )
        ),
        
        // POA Options
        el('div', { className: 'p-4 border border-stone-200 space-y-4' },
            el('h4', { className: 'font-serif text-lg' }, 'POA Options'),
            el('div', { className: 'flex flex-wrap gap-6' },
                el('div', { className: 'flex items-center space-x-2' },
                    el(Checkbox, { id: 'durable', checked: form.power_of_attorney.durable, onCheckedChange: c => updatePOA('durable', c) }),
                    el(Label, { htmlFor: 'durable' }, 'Durable POA'),
                    el('span', { className: 'text-xs text-muted-foreground ml-1' }, '(Remains effective if incapacitated)')
                ),
                el('div', { className: 'flex items-center space-x-2' },
                    el(Checkbox, { id: 'springing', checked: form.power_of_attorney.springing, onCheckedChange: c => updatePOA('springing', c) }),
                    el(Label, { htmlFor: 'springing' }, 'Springing POA'),
                    el('span', { className: 'text-xs text-muted-foreground ml-1' }, '(Only effective upon incapacity)')
                )
            )
        )
    );
}
